import { UpsellModal } from "@codway-dev/ui";
import type { ButtonStyle, UpsellModalProduct } from "@codway-dev/ui";

// ─── Section 10: Preview ──────────────────────────────────────────────────────

interface OneClickEditorPreviewProps {
  product: UpsellModalProduct | null;
  titleTemplate: string;
  subtitleTemplate: string;
  productTitleOverride: string;
  description: string;
  titleColor: string;
  priceColor: string;
  acceptStyle: ButtonStyle;
  declineStyle: ButtonStyle;
  hideCloseIcon: boolean;
  enableQuantitySelector: boolean;
  hideVariantSelector: boolean;
  countdownLabel: string;
  countdownHours: number;
  countdownMinutes: number;
  countdownSeconds: number;
}

const NOOP = () => {};

export function OneClickEditorPreview({
  product,
  titleTemplate,
  subtitleTemplate,
  productTitleOverride,
  description,
  titleColor,
  priceColor,
  acceptStyle,
  declineStyle,
  hideCloseIcon,
  enableQuantitySelector,
  hideVariantSelector,
  countdownLabel,
  countdownHours,
  countdownMinutes,
  countdownSeconds,
}: OneClickEditorPreviewProps) {
  return (
    <div className="sticky top-4">
      <s-box
        background="base"
        border="small subdued solid"
        borderRadius="large-100"
        padding="large-400"
      >
        <s-stack direction="block" gap="base">
          <s-stack direction="inline" gap="small-200" alignItems="center">
            <s-icon type="view" />
            <s-text type="strong">Vista previa</s-text>
          </s-stack>

          {!product ? (
            <s-banner tone="warning">
              <s-text>
                Selecciona el producto para el upsell para ver la vista previa.
              </s-text>
            </s-banner>
          ) : (
            <UpsellModal
              key={product.id}
              product={product}
              titleTemplate={titleTemplate}
              subtitleTemplate={subtitleTemplate}
              productTitleOverride={productTitleOverride}
              descriptionOverride={description}
              titleColor={titleColor}
              priceColor={priceColor}
              acceptStyle={acceptStyle}
              declineStyle={declineStyle}
              hideCloseIcon={hideCloseIcon}
              enableQuantitySelector={enableQuantitySelector}
              hideVariantSelector={hideVariantSelector}
              countdown={{
                label: countdownLabel,
                hours: countdownHours,
                minutes: countdownMinutes,
                seconds: countdownSeconds,
              }}
              onAccept={NOOP}
              onDecline={NOOP}
              onClose={NOOP}
            />
          )}
        </s-stack>
      </s-box>
    </div>
  );
}
